module.exports = __webpack_public_path__ + "static/media/phoenix2.02cd924b.jpg";